import { axiosNT, axiosNTL, axiosUpload } from '../../../services/axios';

const preSignedURL = async (params: any) => {
    return axiosNTL.get('aws', { params })
        .then((res: any) => {
            const { aws }: { aws: any } = res.responseObject || {};
            return Promise.resolve(aws);
        });

}

const b64toBlob = (b64Data: any, sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, {type: 'image/png'});
    const file = new File([blob], 'fileName', { type: 'image/png' });
    return file;
  }

const uploadThumbnailUrl = async (file: any) => {
    try {
        const image = b64toBlob(file)
        const awsObject: any = await preSignedURL({contentType: 'png', type: 'thumbnail'});
        if (awsObject && awsObject.signedUrl) {
            const presignedPostData = awsObject.signedUrl
            let formData = new FormData();
            Object.keys(presignedPostData.fields).forEach(key => {
            formData.append(key, presignedPostData.fields[key]);
            });
            formData.append('file', image);
            await axiosUpload.post(`${awsObject.signedUrl.url}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return Promise.resolve(awsObject.Key)
        }
    } catch (err) {
        return ''
    }
}
const uploadVideo = async (file: any, onUploadProgress: any, cancelToken: any, id?:any ) => {
    try {
        const awsObject: any = await preSignedURL({ id, contentType: 'mp4' });
        if (awsObject && awsObject.signedUrl) {
            await axiosUpload.put(`${awsObject.signedUrl}`, file, {
                headers: {
                    "Content-Type": file.type,
                },
                onUploadProgress,
                cancelToken
            });
            return getHlsUrl(awsObject.Key);
        }
    } catch (error) {
        return Promise.reject(error);
    }
};

//**********************  upload thumbanail ****************** */
const uploadThumbnail = async (file: any, time: number) => {
    return axiosNTL.get(`/aws/thumbnail?key=${file}&time=${time}`).then((response: any) => {
        const { thumbnail }: { thumbnail: any } = response.responseObject || {};
        return Promise.resolve(thumbnail);
    }).catch(err => {
        return Promise.reject(err);
    })
};

//**********************  upload video from url ****************** */
const uploadUrl = async (url: string, cancelToken: any, id?: any) => {
    let endpoint = `video/url/?contentType=mp4&url=${url}`;
    if (id) endpoint+= `&id=${id}`;
    return axiosNTL.get(endpoint, { cancelToken })
        .then((res: any) => {
            const { video }: { video: any } = res.responseObject || {};
            const index = video.url.lastIndexOf('/');
            const key = video.url.slice(index + 1);
            return getHlsUrl(key);
        });

};

const getHlsUrl = async (key: any) => {
    return await axiosNTL.get(`video/hls?key=${key}`)
        .then((res: any) => {
            const { video }: { video: any } = res.responseObject || {};
            return Promise.resolve(video);
        }).catch((error) => {
            return Promise.reject(error);
        })
};

interface deleteVideoThumbnailPayload  {
    videoKey?: string,
    id?: string,
    completionPercent?: Number,
    thumbnailKey?: string
};

const deleteVideoService = async (payload: deleteVideoThumbnailPayload = {}) => {
    return axiosNT.delete(`video/`, { params: payload})
    .then((res: any) => {
            return Promise.resolve(res);
    });
  
};
const videoUploadService = {
    uploadVideo,
    uploadThumbnail,
    uploadUrl,
    getHlsUrl,
    deleteVideoService,
    uploadThumbnailUrl
};

export default videoUploadService;
